export default "__VITE_ASSET__DJuVC535__"